<template>
  <div>
    <box :title="$t('downloadFiles')">
      <div class="pa-3 d-flex flex-column">
        <div class="mb-1">
          <span>انتخاب قالب : </span>
          <v-btn
            :color="$vuetify.theme.dark ? '' : 'primary'"
            outlined
            @click="changeTheme"
            >{{ themeName || "قالب پیشفرض" }}</v-btn
          >
        </div>
        <!-- <div class="d-flex my-2">
          <span class="center">نوع ورود به سیستم:</span>
          <v-radio-group
            hide-details=""
            v-model="rblLoginType"
            class="ma-0"
            row
          >
            <v-radio label="از طریق Active Directory" :value="1"></v-radio>
            <v-radio label="ورود دستی" :value="0"></v-radio>
          </v-radio-group>
        </div> -->

        <div class="d-flex">
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="btnSaveClick">ذخیره تنظیمات</v-btn>
        </div>

        <a
          href="https://www.mozilla.org/en-US/firefox/download/thanks/"
          class="my-1 text"
          >دریافت مرورگر Firefox</a
        >
        <a href="https://www.google.com/chrome/" class="my-1 text"
          >دریافت مرورگر Chrome</a
        >
      </div>
    </box>
    <theme-changer ref="ThemeChanger" @change="themeChanged" />
  </div>
</template>

<script>
import ThemeChanger from "../../components/widget/ThemeChanger.vue";
import EosToastType from "../../model/EosToastType";
import ResultType from "../../model/ResultType";
export default {
  components: { ThemeChanger },

  data() {
    return {
      themeName: "",
      colorNumber:"",
      rblLoginType: "",
    };
  },
  mounted() {
    this.pageLoad();
  },
  methods: {
    pageLoad() {
      this.themeName = this.$vuetify.theme.themes.name;

      // this.$store.dispatch("UseActiveDirectory").then((result) => {
      //   console.log(result);
      //   if (result.type === ResultType.success) {
      //     this.rblLoginType = result.data ? 1 : 0;
      //   }
      // });
    },
    changeTheme() {
      // debugger;
      this.$refs.ThemeChanger.show();
      
    },
    themeChanged() {
      this.themeName = this.$vuetify.theme.themes.name;
      this.colorNumber = this.$vuetify.theme.themes.colorNumber;
      localStorage.setItem("newItem", this.colorNumber);
      // console.log(this.$vuetify.theme);
      // console.log("+++");
      // if(this.themeName=="قالب اصلی"){
      //   this.themeName="1";
      // }else if(this.themeName=="قالب نارنجی"){

      // }else if(this.themeName=="قالب سبز"){

      // }else if(this.themeName=="قالب آبی"){

      // }
      debugger;
    },
    btnSaveClick() {
      var changedTheme=this.colorNumber.replace(/\s+/g, '');
      debugger
      if (!changedTheme) {
        let personel = this.$store.state.personel.personelDetail;
        if (personel.Them) {
          this.colorNumber = personel.Them;
        }
        else {
          this.colorNumber = "1";
        }
      }
      // if(this.rblLoginType==1){
      //   localStorage.removeItem("domainLoginName");
      // }
      
      this.$store
        .dispatch("ChangeSetting", {
          params: {
            theme: this.colorNumber.replace(/\s+/g, ''),
            useActiveDirectory: this.rblLoginType,
            themeName:this.themeName,
          },
        })
        .then((result) => {
          debugger;
          console.log(result);
          if (result.type === ResultType.success && result.data) {
            this.$EosToast.show({
              type: EosToastType.success,
              msg: this.$t("operationSuccess"),
            });
          } else {
            this.$EosToast.show({
              type: EosToastType.error,
              msg: result.error || this.$t("operationFailed"),
            });
          }
        });
        debugger
    },
  },
};
</script>

<style>
</style>